module.exports = __webpack_public_path__ + "static/media/relaciones.b5bf4ff7.svg";